import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { FormattedMessage } from 'react-intl'
import styles from './_routeLanding.css'
import { Heading, SubHeading, ImageGrid } from 'components/util'
import CityRoutes from './CityRoutes'
import CreateRouteMessages from './CreateDiscoverRouteSection/CreateRouteMessages'
import DiscoverRouteMessages from './CreateDiscoverRouteSection/DiscoverRouteMessages'
import CreateDiscoverRouteSection from './CreateDiscoverRouteSection'
import BlogMessages from './BlogMessages'
import * as eventActions from 'services/events/actions'

const mapStateToProps = () => ({})

const mapDispatchToActions = {
  ...eventActions,
}

function RouteLandingPage (props) {
  const headingStyles = {
    color: 'white',
    align: 'left',
    barWidth: '64px',
    tabletFontSize: '48px',
    letterSpacing: '2px',
  }
  const subHeadingStyles = {
    color: 'white',
    align: 'left',
    tabletFontSize: '16px',
    mobileFontSize: '16px',
    maxWidth: '290px',
  }
  const { buttonClickedEvent, blogClickedEvent } = props

  return (
    <div className={styles.landingPage}>
      <Helmet
        title='Routes'
        meta={[
          {
            'name': 'description',
            'content': 'Blaze New Trails with MapMyFitness',
          },
        ]} />
      <div className={styles.routeWrapper}>
        <div className={styles.heroRoutes}>
          <div className={styles.blazeNewTrails}>
            <Heading {...headingStyles} bottomBar={true}>
              <FormattedMessage id='route.landing.herotitle'
                defaultMessage='Blaze New Trails' />
            </Heading>
            <SubHeading {...subHeadingStyles}>
              <FormattedMessage id='route.landing.herocaption'
                defaultMessage='Create, discover, and save your favorites&nbsp;&mdash;&nbsp;from your neighborhood to around the world.' />
            </SubHeading>
          </div>
          <div className={styles.routeContent}>
            <CreateDiscoverRouteSection
              icons={CreateRouteMessages.icons}
              messages={CreateRouteMessages.messages}
              href='/routes/create'
              logEvent={buttonClickedEvent} />
            <div><hr className={styles.routeSplitter} /></div>
            <CreateDiscoverRouteSection
              icons={DiscoverRouteMessages.icons}
              messages={DiscoverRouteMessages.messages}
              href='/routes/search'
              logEvent={buttonClickedEvent} />
          </div>
        </div>
        <CityRoutes />
        <ImageGrid items={BlogMessages}
          title={<FormattedMessage id='route.landing.blog.blogarticles' defaultMessage='Blog Articles' />}
          className={styles.blogContainer}
          logEvent={blogClickedEvent}
        />
      </div>
    </div>
  )
}

RouteLandingPage.propTypes = {
  buttonClickedEvent: PropTypes.func,
  blogClickedEvent: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToActions)(RouteLandingPage)
